import RangeDatesSelectorPanel from "./RangeDatesSelectorPanel";

export default RangeDatesSelectorPanel;